import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function UpdateSettings() {
    const [settingKey, setSettingKey] = useState('');
    const [settingValue, setSettingValue] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        const fetchSetting = async () => {
            try {
                const res = await axios.get(process.env.REACT_APP_API_URL + 'settings/' + id);
                setSettingKey(res.data.setting_key);
                setSettingValue(res.data.setting_value);
            } catch (error) {
                console.error(error);
            }
        };
        fetchSetting();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(process.env.REACT_APP_API_URL + 'settings/' + id, {
                setting_key: settingKey,
                setting_value: settingValue
            });
            navigate('/settingslist');
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='container mt-4'>
            <h4>Update Setting</h4>
            <form onSubmit={handleSubmit}>
                <div className='mb-3'>
                    <label className='form-label'>Setting Key</label>
                    <input
                        type='text'
                        className='form-control'
                        value={settingKey}
                        onChange={(e) => setSettingKey(e.target.value)}
                        required
                    />
                </div>
                <div className='mb-3'>
                    <label className='form-label'>Setting Value</label>
                    <input
                        type='text'
                        className='form-control'
                        value={settingValue}
                        onChange={(e) => setSettingValue(e.target.value)}
                        required
                    />
                </div>
                <button type='submit' className='btn btn-primary'>Update</button>
                <button type='button' className='btn btn-secondary ms-2' onClick={() => navigate('/settingslist')}>Cancel</button>
            </form>
        </div>
    );
}

export default UpdateSettings;